module.exports = __webpack_public_path__ + "media/luxury-2026/formal-dining-960-96eb4970.jpg";